// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd6231c5","455":"4815be2c"}[chunkId] + ".chunk.js";
};